export default __webpack_public_path__ + "static/media/SWT0030.34I-27134_-16414_0.be5c1c8b.jpg";